import React from "react";

const Technologies = ({ tech }) => {
  return (
    <div className="d-flex flex-wrap gap-1 align-items-center justify-content-center" style={{ width: "170px" ,color:'#6a6a6a',opacity:'0.8'}}>
      { tech?.map((ele, i) => (
        <span
          className="rounded"
          key={i}
          style={{ padding: "2px 5px", fontSize: "1rem", backgroundColor: "rgb(248 235 232)", fontWeight: "500" }}
        >
          {ele}
        </span>
      ))}
    </div>
  );
};

export default Technologies;
